import { Permisos } from '@/shared/constants/permisos';
import type { TourDefinicion } from '@/features/guia-interactiva/types/guia-interactiva.types';

export const tourConfiguracionParametros: TourDefinicion = {
  codigo: 'configuracion-parametros',
  titulo: 'Parámetros',
  descripcion: 'Valores configurables consultados por el backend en runtime.',
  ruta: '/admin/configuracion/parametros',
  permisoMenu: Permisos.PARAMETROS_MENU,
  pasos: [
    {
      id: 'configuracion-parametros:header',
      selector: '[data-testid="configuracion-parametros.header"]',
      titulo: 'Parámetros del sistema',
      descripcion:
        'Catálogos y flags que el backend consulta en runtime. Úsalos para cambiar comportamiento sin modificar código.',
      side: 'bottom',
      align: 'start',
    },
    {
      id: 'configuracion-parametros:boton-crear',
      selector: '[data-testid="configuracion-parametros.boton-crear"]',
      titulo: 'Nuevo parámetro',
      descripcion:
        'Agrega un parámetro con tipo, código, valor y orden. Queda disponible inmediatamente.',
      permisoRequerido: Permisos.PARAMETROS_CREAR,
      side: 'left',
      align: 'center',
    },
    {
      id: 'configuracion-parametros:tabla',
      selector: '[data-testid="configuracion-parametros.tabla"]',
      titulo: 'Listado por tipo',
      descripcion:
        'Filtra por tipo de parámetro desde el selector superior. Edita o elimina cada valor desde la fila.',
      side: 'top',
      align: 'center',
    },
  ],
};
